const SET_STATE = 'SET_STATE';

export default {
	SET_STATE
};
